import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const McoInvLineList = ({ mcoInv }) => {
  const augRowsReq = useCallback((rowsReq) => {
    if (!mcoInv) return;
    rowsReq.expr = ExprUtils.and(
      rowsReq.expr,
      ExprUtils.whereParams(
        'invPeriodId',
        mcoInv.invPeriodId,
        'mcoInvId',
        mcoInv.id,
      ),
    );
  }, []);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); // Utlization Lines come from system only
  };

  const augFieldDefs = (fieldToFieldDef) => {
    // 1. Dimensions
    fieldToFieldDef.planCustId.precedence = 100;
    fieldToFieldDef.planCustId.hasName = true;

    fieldToFieldDef.invPeriodId.precedence = 101;
    fieldToFieldDef.invPeriodId.hasName = false;

    fieldToFieldDef.prodId.precedence = 102;
    fieldToFieldDef.prodId.hasName = false;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;
    fieldToFieldDef.bucketed.precedence = 1002;

    // 3. Units
    fieldToFieldDef.invRxs.precedence = 2000;
    fieldToFieldDef.invUnits.precedence = 2001;
    fieldToFieldDef.incrInvUnits.precedence = 2002;
    fieldToFieldDef.incrDispUnits.precedence = 2003;
    fieldToFieldDef.incrDueUnits.precedence = 2004;
    fieldToFieldDef.incrPaidUnits.precedence = 2005;
    fieldToFieldDef.openDispUnits.precedence = 2006;
    fieldToFieldDef.calcDispUnits.precedence = 2007;

    // 4. Amounts
    fieldToFieldDef.invAmt.precedence = 3000;
    fieldToFieldDef.extInvAmt.precedence = 3001;
    fieldToFieldDef.reimbAmt.precedence = 3002;
    fieldToFieldDef.patientLiab.precedence = 3003;
    fieldToFieldDef.incrInvAmt.precedence = 3004;
    fieldToFieldDef.incrDispAmt.precedence = 3005;
    fieldToFieldDef.incrDueAmt.precedence = 3006;
    fieldToFieldDef.incrPaidAmt.precedence = 3007;

    // 5. Disputes
    fieldToFieldDef.disputed.precedence = 4000;
    fieldToFieldDef.dispCodeStr.precedence = 4001;
    fieldToFieldDef.adjCodeStr.precedence = 4002;
  };

  return (
    <EntityList
      entity="MCO_INV_LINE"
      augRowsReq={augRowsReq}
      augTabButtons={augTabButtons}
      augFieldDefs={augFieldDefs}
    />
  );
};
